import service from './baseService';
import { getCompanyId } from '../config';

export const getTripRecordsService = (dispatchID) => {
    return service.get(`/trip-records`, {
        params: {
            companyId: getCompanyId(),
            dispatchID,
        },
    });
};

export const createTripRecordService = (data) => {
    return service.post(`/trip-records`, data, {
        params: { companyId: getCompanyId() },
    });
};

export const updateTripRecordService = (id, data) => {
    return service.put(`/trip-records/${id}`, data, {
        params: { companyId: getCompanyId() },
    });
};

export const deleteTripRecordService = (id) => {
    return service.delete(`/trip-records/${id}`, {
        params: { companyId: getCompanyId() },
    });
};
